var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.clients),function(client){return _c('ClientRow',{key:client.id,attrs:{"client":client},on:{"new-reservation-client-click":_vm.newReservationClientClick}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }